import React from 'react';

const MenuButton = props => <a { ...props }><div></div></a>;

export default MenuButton;
